export type ConditionRaw =
  | {
      or: { conditions: ConditionRaw[] };
    }
  | {
      and: { conditions: ConditionRaw[] };
    }
  | FilterConditionDto;

export interface FilterConditionDto {
  [key: string]: unknown;
}

export abstract class BdCondition {
  protected constructor(public id: string) {}

  public abstract toJSON(): ConditionRaw;
}

export enum BdConditionComparison {
  LESS_OR_EQUAL = 'LESS_OR_EQUAL',
  GREATER_OR_EQUAL = 'GREATER_OR_EQUAL',
}

export enum BdConditionEmptyArrayStrategy {
  LEGACY,
  AS_NULL,
}

export class BdContentCondition<T> extends BdCondition {
  protected constructor(
    id: string,
    public includes: T[] = [],
    public excludes: T[] = [],
    protected _emptyArrayStrategy: BdConditionEmptyArrayStrategy = BdConditionEmptyArrayStrategy.AS_NULL,
  ) {
    super(id);
  }

  toJSON(): FilterConditionDto {
    return {
      [this.id]: {
        includes: this._arrayToJson(this.includes, this._emptyArrayStrategy),
        excludes: this._arrayToJson(this.excludes, this._emptyArrayStrategy),
      },
    };
  }

  protected _arrayToJson(
    value: T[],
    emptyArrayStrategy: BdConditionEmptyArrayStrategy = BdConditionEmptyArrayStrategy.AS_NULL,
  ): T[] | null {
    if (emptyArrayStrategy === BdConditionEmptyArrayStrategy.LEGACY) {
      return value;
    } else {
      if (value?.length > 0) {
        return value;
      } else {
        return null;
      }
    }
  }
}
